import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionPageDescription from '../ActionPageDescription';
import { Heading, Icon } from '@innovationnorway/cl-react';
const CommunicationBetweenActors: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { t: tHelpAndSupport } = useTranslation('onboarding');
  return (
    <>
      <Heading className="margin-bottom--6" level={3} data-size="sm">
        {tHelpAndSupport('commonQuestions.Interplay.CommunicationBetweenActors')}
      </Heading>
      <div className="display--flex flex-direction--column gap--6">
        <ActionPageDescription
          icon={<Icon prefix="fass" iconName="paper-plane" />}
          iconName={tOneWayIn('details.Title.Referrer')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.ReferrerDescription')}
        />
        <ActionPageDescription
          icon={<Icon prefix="fasr" iconName="note-sticky" />}
          iconName={tCommon('note')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.NoteDescription')}
        />
        <ActionPageDescription
          icon={<Icon prefix="fasr" iconName="list-timeline" />}
          iconName={tOneWayIn('details.Title.ActivityLog')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.ActivityLogDescription')}
        />
        <ActionPageDescription
          icon={<Icon prefix="fasr" iconName="box-archive" />}
          iconName={tOneWayIn('details.Title.Archiving')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.ArchivingDescription')}
        />
      </div>
    </>
  );
};
export default CommunicationBetweenActors;
